import useRequest from '@/websdk/utils/request';
export default (function () {
  const { isRequestSuccessed, data } = useRequest({
    url: '/api/inspection/method?is_deleted=0',
    name: 'inspectionMethodGet',
    method: 'GET'
  });
  return [data || [], isRequestSuccessed];
})
